import { baseApi } from 'services'

import { User } from '@/types/unlock'

export const applicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoggedUser: builder.query<User, void>({
      query: () => 'logged-user/',
      providesTags: ['UserData'],
    }),
    getToken: builder.mutation<any, any>({
      query: (data) => ({
        url: `v1/token-auth/`,
        method: 'POST',
        body: data,
      }),
    }),
    getAllUsers: builder.query<User[], void>({
      query: () => `v2/user`,
    }),
    getStaffUsers: builder.query<User[], void>({
      query: () => `v2/user/?is_staff=true`,
      providesTags: ['UserData'],
    }),
    getForgotPassword: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/user/recover-password/`,
        method: 'POST',
        body: data,
      }),
    }),
    getCheckToken: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/user/check-token-password/${data.token}/`,
        method: 'POST',
      }),
    }),
    patchUser: builder.mutation<any, any>({
      query: ({ id, data }) => ({
        url: `v2/user/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['UserData', 'ApplicationAllUsersData'],
    }),
    handleChangePassword: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/user/set-new-password/${data.token}/`,
        method: 'POST',
        body: data,
      }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: `v2/user/logout/`,
        method: 'POST',
      }),
      invalidatesTags: ['UserData'],
    }),
    setUserControlledFeatureFlag: builder.mutation<void, void>({
      query: () => ({
        url: `v2/user/set-user-controlled-feature-flag/`,
        method: 'POST',
      }),
      invalidatesTags: ['UserData'],
    }),
    setUserDefaultPreset: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/user/set-user-default-preset/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UserData'],
    }),
    ssoMicrosoftLogin: builder.mutation<any, { accessToken: string }>({
      query: ({ accessToken }) => ({
        url: `sso/microsoft/login/`,
        method: 'POST',
        body: { accessToken },
      }),
    }),
  }),
})

export const {
  useGetLoggedUserQuery,
  useLazyGetLoggedUserQuery,
  useGetTokenMutation,
  useGetAllUsersQuery,
  useGetStaffUsersQuery,
  useGetForgotPasswordMutation,
  useGetCheckTokenMutation,
  useHandleChangePasswordMutation,
  useLogoutMutation,
  useSetUserControlledFeatureFlagMutation,
  useSetUserDefaultPresetMutation,
  usePatchUserMutation,
  useSsoMicrosoftLoginMutation,
} = applicationApi
